export default __webpack_public_path__ + "static/media/AssertivenessDelivering.e63844a7.png";